import * as angular from 'angular';
import { Growl } from 'angular/custom/services/growl.service';

(function () {
    'use strict';

    angular
        .module('app')
        .controller(
            'DashboardPlatformSettingsCtrl',
            DashboardPlatformSettingsCtrl
        );

    function DashboardPlatformSettingsCtrl(
        platformSettingsService,
        ShipperUser,
        growl: Growl
    ) {
        var vm = this;

        var originalCorrelatedWidgets: any = {};

        vm.deactivateWidget = deactivateWidget;
        vm.activateWidget = activateWidget;
        vm.submitDashboardSettings = submitDashboardSettings;
        vm.cancelDashboardSettings = cancelDashboardSettings;
        vm.dashboardSettingsForm = {};
        vm.niceWidgetName = platformSettingsService.niceWidgetName;
        vm.savingFailed = null;

        ShipperUser.getSettings({ setting: 'dashboard' }, function (res) {
            var correlatedWidgets =
                platformSettingsService.correlateActiveAndInactiveWidgets(
                    res.activeWidgetList
                );
            originalCorrelatedWidgets = angular.copy(correlatedWidgets);
            vm.activeWidgets = correlatedWidgets.activeWidgets;
            vm.inactiveWidgets = correlatedWidgets.inactiveWidgets;
        });

        function deactivateWidget(widget) {
            vm.inactiveWidgets.push(angular.copy(widget));
            vm.activeWidgets.splice(vm.activeWidgets.indexOf(widget), 1);
        }

        function activateWidget(widget) {
            vm.activeWidgets.push(angular.copy(widget));
            vm.inactiveWidgets.splice(vm.inactiveWidgets.indexOf(widget), 1);
        }

        function submitDashboardSettings(isValid) {
            if (!isValid) {
                return false;
            }

            ShipperUser.saveSettings(
                { setting: 'dashboard' },
                { activeWidgetList: vm.activeWidgets },
                function () {
                    growl.show(
                        'Your general platform changes have been saved successfully.',
                        'success'
                    );
                },
                function (err: ng.IHttpPromiseCallbackArg<RestError>) {
                    const errorCode =
                        err && err.data && err.data.errorCode
                            ? err.data.errorCode
                            : '';
                    growl.show(
                        'Unfortunately something went wrong, please try again later.',
                        'danger',
                        { errorCode }
                    );
                }
            );
        }

        function cancelDashboardSettings() {
            vm.activeWidgets = angular.copy(
                originalCorrelatedWidgets.activeWidgets
            );
            vm.inactiveWidgets = angular.copy(
                originalCorrelatedWidgets.inactiveWidgets
            );
        }
    }
})();
